import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { DialogComponent } from '../../../CommonComponent/DialogComponent';
import { Enums } from '../../../../../config/enums';
import { useDispatch } from 'react-redux';
import { defaultOkrDelete } from '../../../../../action/adminDefaultOkr';

export const DeleteModal: React.FC<any> = (props: any) => {
	const {
		modalProps,
		setModalProps,
		setShowLoader,
		mode,
		handleBackButtonOnClick,
		setIsDefaultOkrFormEdited,
		defaultOkrFormDetails,
		setDefaultOkrFormDetails,
		showApiMsg,
		handlePublishDefaultOkrClick,
	} = props;
	const { t } = useTranslation();
	const dispatch = useDispatch();

	React.useEffect(() => {}, [modalProps]);
	const deleteDefaultOkr = async (deletionId: any, deleteType: string, details: any = {}, type: number) => {
		try {
			if (deletionId) {
				setShowLoader(true);
				const isGoalObjective = deleteType === 'OKR' ? true : false;
				const requestParams = `id=${deletionId}&isGoalObjective=${isGoalObjective}&isApplyInCurrentCycle=${
					type === 1 ? true : false
				}`;
				const response: any = await dispatch(defaultOkrDelete(requestParams));
				if (response && response?.data && response?.data?.status === Enums.STATUS_SUCCESS) {
					// defaultOkrAPICall();
					if (deleteType === 'OKR') {
						handleBackButtonOnClick();
					} else {
						setShowLoader(false);
						const { indexValue } = details;
						const { defaultGoalKeys } = defaultOkrFormDetails;
						const updatedDefaultGoalKeys = defaultGoalKeys.filter(
							(rec: any, itemIndex: number) => itemIndex !== indexValue
						);
						const updatedDefaultGoalKeys2 = [...updatedDefaultGoalKeys].filter(
							(rec: any, itemIndex: number) => rec?.name || rec?.name?.trim() !== ''
						);
						if (updatedDefaultGoalKeys2.length === 0) {
							handleBackButtonOnClick();
						}
					}
				} else {
					const { messageList } = response?.data || {};
					const keys = messageList ? Object.keys(messageList) : null;
					const messages = keys && keys?.length ? keys.map((item) => messageList[item]) : [];
					showApiMsg('error', messages || t('FetchingDefaultOkrError'));
				}
			}
		} catch (error) {
			console.error(error);
		}
	};
	const handleConfirmationCloseModal = async (e: any, type: any) => {
		try {
			if (type === 1 || type === 3) {
				const { details } = modalProps || {};
				console.log('details', details, type);
				if (details && details?.deleteType === 'OKR') {
					if (mode === 'Add') {
						handleBackButtonOnClick();
					} else {
						console.log('deleteDefaultOkr', details?.okrDetails?.defaultGoalObjectiveId, details?.deleteType);
						deleteDefaultOkr(details?.okrDetails?.defaultGoalObjectiveId, details?.deleteType, {}, type);
					}
				} else if (details && details?.deleteType === 'KR') {
					const { item, indexValue } = details;
					const { defaultGoalKeys } = defaultOkrFormDetails;
					if (mode === 'Add' || !item?.defaultGoalKeyId) {
					} else {
						//console.log('deleteDefaultOkr222', item?.defaultGoalKeyId, details?.deleteType, details);
						deleteDefaultOkr(item?.defaultGoalKeyId, details?.deleteType, details, type);
					}
					if (defaultGoalKeys && defaultGoalKeys?.length) {
						const updatedDefaultGoalKeys = defaultGoalKeys.filter(
							(rec: any, itemIndex: number) => itemIndex !== indexValue
						);
						setDefaultOkrFormDetails({ ...defaultOkrFormDetails, defaultGoalKeys: updatedDefaultGoalKeys });
						setIsDefaultOkrFormEdited(true);
					} else {
						handleBackButtonOnClick();
					}
				} else if (details && details?.deleteType === 'publish') {
					handlePublishDefaultOkrClick(details.event, false, type);
				}
				setModalProps({ open: false, message: '', details: '' });
			} else {
				setModalProps({ open: false, message: '', details: '' });
			}
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<>
			{modalProps && modalProps.open && (
				<DialogComponent
					module={modalProps.module || 'defaultKR'}
					modalOpen={modalProps.open}
					onFirst={(e: any) => handleConfirmationCloseModal(e, 2)}
					onSecond={(e: any) => handleConfirmationCloseModal(e, 1)}
					onThird={(e: any) => handleConfirmationCloseModal(e, 3)}
					handleCloseModal={(e: any) => handleConfirmationCloseModal(e, 2)}
					matchString={modalProps?.details?.matchString || Enums.DELETE_TEXT}
					handleConfirmClick={(e: any) => handleConfirmationCloseModal(e, 1)}
					confirmMsg={modalProps?.details?.confirmMsg || ''}
					headingText={
						modalProps?.details && modalProps?.details?.deleteType === 'publish'
							? t('kpiPublish')
							: modalProps?.details?.headingText || ''
					}
					subHeading={
						modalProps?.details && modalProps?.details?.deleteType === 'publish' ? (
							<p
								dangerouslySetInnerHTML={{
									__html:
										'The KPI cycle has already started.<br/>Do you want to publish it in the current cycle or the next cycle?',
								}}
							/>
						) : (
							<p dangerouslySetInnerHTML={{ __html: modalProps?.details?.subHeading || '' }} />
						)
					}
					threeButtonText={
						modalProps?.details && modalProps?.details?.deleteType === 'publish'
							? { first: 'Cancel', second: 'Publish for current cycle', third: 'Publish for next cycle' }
							: { first: 'Cancel', second: 'Delete for current cycle', third: 'Delete for next cycle' }
					}
				/>
			)}
		</>
	);
};
